import React, { useEffect, useState } from "react";
import { Box, Container, Typography } from "@mui/material";
import WhatWeDoSection from "./components/WhatWeDoSection";
import ServicesBannerImg from "../../assets/media/services-banner-img.svg";
import "./services-page.scss";

function ServicesPage() {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [delayPassed, setDelayPassed] = useState(false);

  // delay for image loading
  useEffect(() => {
    const timer = setTimeout(() => {
      setDelayPassed(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const showBanner = imageLoaded && delayPassed;

  return (
    <Container maxWidth="lg" className="services-page">
      <Box className="services-page__banner-section">
        <Box className="services-page__banner-image-wrapper">
          <img
            src={ServicesBannerImg}
            alt="services-banner-img"
            onLoad={() => setImageLoaded(true)}
            className={showBanner ? "loaded" : ""}
          />

          {showBanner && (
            <Typography
              variant="h5"
              className="services-page__banner-text"
              sx={{ textShadow: "2px 1px 4px rgba(0, 0, 0, 0.6)" }}
            >
              Trusted memorial services honoring lives with respect, love, and
              remembrance.
            </Typography>
          )}
        </Box>
      </Box>

      <Box className="services-page__what-we-do-section">
        <WhatWeDoSection />
      </Box>
    </Container>
  );
}

export default ServicesPage;
